// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"loadingSpinner_loaderContainer__fgyKx","spinner":"loadingSpinner_spinner__M10XI","spin-anim":"loadingSpinner_spin-anim__6pdOC"};